import HttpService from "./HttpService";
const API_ENDPOINT = "/division";

const CityService = {
  async getStateCities(stateId, countryId) {
    try {
      const response = await HttpService.get(
        `/city-get/${stateId}/${countryId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getDivisions() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getDivisionPaginated(pageConfig) {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getDivisionById(divisionId) {
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}/${divisionId}/edit`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async addDivision(data) {
    try {
      const response = await HttpService.post(API_ENDPOINT, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async updateDivision(divisionId, data) {
    try {
      data["_method"] = "PUT";
      const response = await HttpService.post(
        `${API_ENDPOINT}/${divisionId}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async deleteDivision(cityId) {
    try {
      const response = await HttpService.delete(`${API_ENDPOINT}/${cityId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default CityService;
